import { ContentSection } from '../../../../components/LayoutElements';
import { Stack } from '@fluentui/react';
import { SearchFilter } from './components/SearchFilter';
import { ResourceList } from './components/ResourceList';
import { useEffect } from 'react';
import { useStore } from '../../../../store/useStore';

export const ResourceOverview = () => {
    useEffect(() => {
        return () => {
            useStore.getState().setSearchText('');
            useStore.getState().setCurrentUsers([]);
        };
    }, []);

    return (
        <ContentSection>
            <Stack styles={{ root: { width: '100%', maxWidth: 2000 } }} tokens={{ childrenGap: 32 }}>
                <SearchFilter />
                <ResourceList />
            </Stack>
        </ContentSection>
    );
};
